module.exports = __webpack_public_path__ + "static/unused-css-a8e2934ee66cb4df3a353fa4e2574f3a.png";